import React from "react";
import { Grid } from "@mui/material";
import GarantiaAvalistasComponent from "./avalistas";
import DadosGeraisPropostaSection from "../sections/DadosGeraisPropostaSection";

import {
  formatMonetary,
  formatUpperCase,
  formatPercentage,
  timeStampToDate,
} from "../../../../utils/formats";

import {
  ComponentWrapper,
  CardWrapper,
  Label,
  CardFilled,
  Card,
} from "../styles";

import Input from "../ReadOnlyInput";

const GarantiaComponent = (props) => {
  const {
    proposalOperation = {},
    proposalOperationLoading,
    proposalWarrantGuarantorsCustomerAccounts = [],
    proposalWarrantGuarantorsOtherCompanies = [],
    proposalWarrantyGuarantors = [],
    proposalWarrantyGuarantorsLoading,
    proposalWarrantyVehicleInfo = {},
    proposalWarrantyVehicleInfoLoading,
    proposalCompleteRegistration = {},
    proposalCompleteRegistrationLoading,
  } = props;

  return (
    <ComponentWrapper>
      <CardWrapper>
        <Label>Dados gerais da proposta</Label>
        <CardFilled>
          <DadosGeraisPropostaSection
            proposalCompleteRegistrationLoading={
              proposalCompleteRegistrationLoading
            }
            proposalOperationLoading={proposalOperationLoading}
            numeroCpfCnpj={proposalCompleteRegistration.cpfCnpj}
            nomeCliente={proposalCompleteRegistration.nomeCliente}
            nomeConvenio={proposalCompleteRegistration.nomeConvenio}
            nomeFilial={proposalCompleteRegistration.nomeFilial}
            nomeFilialFantasia={proposalCompleteRegistration.nomeFilialFantasia}
            numeroProposta={proposalOperation.numeroProposta}
            produto={proposalOperation.produto}
            nomeAnalista={proposalCompleteRegistration.nomeAnalista}
            descricaoStatus={proposalCompleteRegistration.descricaoStatus}
            rankingRelacionamento={
              proposalCompleteRegistration.rankingRelacionamento
            }
            sistemaOrigem={proposalCompleteRegistration.sistemaOrigem}
            pcLtvRisco={proposalCompleteRegistration.pcLtvRisco}
            pcCompRendaCliente={proposalCompleteRegistration.pcCompRendaCliente}
            idRiscoScrCliente={proposalCompleteRegistration.idRiscoScrCliente}
            idRiscoSerasaCliente={
              proposalCompleteRegistration.idRiscoSerasaCliente
            }
          />
        </CardFilled>
      </CardWrapper>

      <CardWrapper>
        <Label>Veículo</Label>
        <Card>
          <Grid container spacing={4}>
            <Grid item md={3}>
              <Input
                loading={proposalWarrantyVehicleInfoLoading}
                disabled
                label="Marca"
                value={formatUpperCase(proposalWarrantyVehicleInfo.marca)}
              />
            </Grid>
            <Grid item md={3}>
              <Input
                loading={proposalWarrantyVehicleInfoLoading}
                disabled
                label="Modelo"
                value={proposalWarrantyVehicleInfo.modelo}
              />
            </Grid>
            <Grid item md={3}>
              <Input
                loading={proposalWarrantyVehicleInfoLoading}
                disabled
                label="Placa"
                value={proposalWarrantyVehicleInfo.placa}
              />
            </Grid>
            <Grid item md={3}>
              <Input
                loading={proposalWarrantyVehicleInfoLoading}
                disabled
                label="Ano fabr./Ano modelo"
                value={
                  proposalWarrantyVehicleInfo.anoFabricacao
                    ? `${proposalWarrantyVehicleInfo.anoFabricacao}/${proposalWarrantyVehicleInfo.anoModelo}`
                    : ""
                }
              />
            </Grid>

            <Grid item md={3}>
              <Input
                loading={proposalWarrantyVehicleInfoLoading}
                disabled
                label="Renavan"
                value={proposalWarrantyVehicleInfo.renavan}
              />
            </Grid>
            <Grid item md={3}>
              <Input
                loading={proposalWarrantyVehicleInfoLoading}
                disabled
                label="Cor"
                value={formatUpperCase(proposalWarrantyVehicleInfo.cor)}
              />
            </Grid>
            <Grid item md={3}>
              <Input
                loading={proposalWarrantyVehicleInfoLoading}
                disabled
                label="Chassi"
                value={proposalWarrantyVehicleInfo.numeroChassi}
              />
            </Grid>
            <Grid item md={3}>
              <Input
                loading={proposalWarrantyVehicleInfoLoading}
                disabled
                label="Combustível"
                value={formatUpperCase(proposalWarrantyVehicleInfo.combustivel)}
              />
            </Grid>

            <Grid item md={3}>
              <Input
                loading={proposalWarrantyVehicleInfoLoading}
                disabled
                label="CAP/POT/CIL"
                value={`${
                  proposalWarrantyVehicleInfo.capacidadePotenciaCilindradas ??
                  ""
                }`}
              />
            </Grid>
            <Grid item md={3}>
              <Input
                loading={proposalWarrantyVehicleInfoLoading}
                disabled
                label="Natureza (usado/novo)"
                value={proposalWarrantyVehicleInfo.natureza}
              />
            </Grid>
            <Grid item md={3}>
              <Input
                loading={proposalWarrantyVehicleInfoLoading}
                disabled
                label="Estado"
                value={proposalWarrantyVehicleInfo.estado}
              />
            </Grid>
            <Grid item md={3}>
              <Input
                loading={proposalWarrantyVehicleInfoLoading}
                disabled
                label="Valor do Veículo (Garantia)"
                value={formatMonetary(proposalWarrantyVehicleInfo.veiculo)}
              />
            </Grid>

            <Grid item md={6}>
              <Input
                loading={proposalWarrantyVehicleInfoLoading}
                disabled
                label="Código FIPE"
                value={proposalWarrantyVehicleInfo.codigoFipe}
              />
            </Grid>
            <Grid item md={3}>
              <Input
                loading={proposalWarrantyVehicleInfoLoading}
                disabled
                label="Preço FIPE"
                value={formatMonetary(proposalWarrantyVehicleInfo.precoFipe)}
              />
            </Grid>
            <Grid item md={3}>
              <Input
                loading={proposalWarrantyVehicleInfoLoading}
                disabled
                label="Data FIPE"
                value={timeStampToDate(proposalWarrantyVehicleInfo.dataFipe)}
              />
            </Grid>

            <Grid item md={12}>
              <Input
                loading={proposalWarrantyVehicleInfoLoading}
                type="textarea"
                height={200}
                disabled
                label="Débitos, Restrições e Leilão"
                value={
                  !Boolean(proposalWarrantyVehicleInfo.debitos) &&
                  !Boolean(proposalWarrantyVehicleInfo.restricoes)
                    ? "-"
                    : (proposalWarrantyVehicleInfo.debitos ?? "") +
                      "\n\n" +
                      (proposalWarrantyVehicleInfo.restricoes ?? "")
                }
              />
            </Grid>
          </Grid>
        </Card>
      </CardWrapper>

      {(proposalCompleteRegistration.pcCompRendaAvalista != null ||
        proposalCompleteRegistration.idRiscoScrAvalista != null ||
        proposalCompleteRegistration.idRiscoSerasaAvalista != null) && (
        <CardWrapper>
          <Label>Dados do Modelo de Crédito — Avalista</Label>
          <Card>
            <Grid container spacing={3}>
              {proposalCompleteRegistration.pcCompRendaAvalista != null && (
                <Grid item md={4}>
                  <Input
                    loading={proposalCompleteRegistrationLoading}
                    label="Comp. Renda (avalista)"
                    value={formatPercentage(
                      proposalCompleteRegistration.pcCompRendaAvalista
                    )}
                  />
                </Grid>
              )}
              {proposalCompleteRegistration.idRiscoScrAvalista != null && (
                <Grid item md={4}>
                  <Input
                    loading={proposalCompleteRegistrationLoading}
                    label="Risco SCR (avalista)"
                    value={formatUpperCase(
                      proposalCompleteRegistration.idRiscoScrAvalista
                    )}
                  />
                </Grid>
              )}
              {proposalCompleteRegistration.idRiscoSerasaAvalista != null && (
                <Grid item md={4}>
                  <Input
                    loading={proposalCompleteRegistrationLoading}
                    label="Risco Serasa (avalista)"
                    value={formatUpperCase(
                      proposalCompleteRegistration.idRiscoSerasaAvalista
                    )}
                  />
                </Grid>
              )}
            </Grid>
          </Card>
        </CardWrapper>
      )}

      <GarantiaAvalistasComponent
        proposalWarrantGuarantorsOtherCompanies={
          proposalWarrantGuarantorsOtherCompanies
        }
        proposalWarrantGuarantorsCustomerAccounts={
          proposalWarrantGuarantorsCustomerAccounts
        }
        proposalWarrantyGuarantors={proposalWarrantyGuarantors}
        proposalWarrantyGuarantorsLoading={proposalWarrantyGuarantorsLoading}
      />
    </ComponentWrapper>
  );
};

export default GarantiaComponent;
